import { Bubble, Props } from './Bubble';

export const StartedBubble = (props: Props) => (
  <Bubble {...props}>
    <div className="bg-brand rounded-2xl px-4 py-3 drop-shadow-sm">
      <p className="leading-5 text-white">
        占い師の準備が出来ました
        <br />
        鑑定を始めます
      </p>
    </div>
  </Bubble>
);
